import { FilterInterface, Filters } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter';
import { JsonClassType, JsonProperty, ObjectMapper } from '@outfoxx/jackson-js';
import { JsonClassTypeOptions, JsonParserContext } from '@outfoxx/jackson-js/dist/@types';
import { ArrayCollection } from 'lib/base/collection';
import { RefFilter } from 'modules/spravochnik/dt-front-page-generator/src/@Json/Filter';
import { Name } from './index';
import { HasNameInterface } from 'modules/spravochnik/dt-front-page-generator/src/Entity/HasNameInterface';
import { Sort } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';
import { UrlProviderInterface } from 'modules/spravochnik/dt-front-page-generator/src/Entity/UrlProviderInterface';
import _ from 'lodash';

class Seo {
    @JsonProperty()
    metaDescription: string;
    @JsonProperty()
    metaTitle: string;
    @JsonProperty()
    metaImage: object;
}

export class PageIdentity {
    @JsonProperty()
    categoryUrlName: string;
    @JsonProperty()
    pageUrlName: string;

    constructor(categoryUrlName: string, pageUrlName: string) {
        this.categoryUrlName = categoryUrlName;
        this.pageUrlName = pageUrlName;
    }

    public equals(identity: PageIdentity): boolean {
        return this.categoryUrlName === identity.categoryUrlName && this.pageUrlName === identity.pageUrlName;
    }
}

export class Page implements HasNameInterface, UrlProviderInterface {
    private static _ALLOWED_SORT = [
        new Sort('По возрастанию', 'sort', 'asc', true),
        new Sort('По убыванию', 'sort', 'desc'),
        new Sort('По названию (А-Я)', 'name', 'asc'),
        new Sort('По названию (Я-А)', 'name', 'desc'),
    ];

    @JsonProperty({ value: 'identity' })
    @JsonClassType(<JsonClassTypeOptions> { type: () => [PageIdentity] })
    private _identity: PageIdentity;
    @JsonProperty()
    countItems: number;
    @JsonProperty()
    icon: any;
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> { type: () => [Name] })
    name: Name;
    @JsonProperty()
    image: object;
    @JsonProperty()
    sort: number;
    @JsonProperty()
    categoryName: string;
    @JsonProperty()
    dateCreate: number;
    @JsonProperty()
    dateUpdate: number;
    @JsonProperty()
    description: string;
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> { type: () => [Seo] })
    seo: Seo;

    @JsonProperty({ value: 'filters' })
    @JsonClassType(<JsonClassTypeOptions> { type: () => [ArrayCollection, [RefFilter]] })
    private _filters: ArrayCollection<FilterInterface>;

    private _filtersObj: Filters | null;

    sortMode: Sort = Page._ALLOWED_SORT[0];

    public static createByObj(object: object | null): Page {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<Page>(JSON.stringify(object), { mainCreator: () => [Page] } as JsonParserContext);
    }

    get allowedSortModes(): Sort[] {
        return Page._ALLOWED_SORT;
    }

    get identity(): PageIdentity {
        return this._identity;
    }

    get filters(): Filters {
        if (this._filtersObj) {
            return this._filtersObj;
        }

        return this._filtersObj = new Filters(_.clone(this._filters));
    }

    public getUrl(): any {
        return {
            name: 'page',
            params: {
                categoryUrlName: this._identity.categoryUrlName,
                pageUrlName: this._identity.pageUrlName
            }
        };
    }

    public getMapUrl(): any {
        return {
            name: 'page-map',
            params: {
                categoryUrlName: this._identity.categoryUrlName,
                pageUrlName: this._identity.pageUrlName,
            }
        };
    }
}

